import styled from "styled-components";

export const Container = styled.div`
   margin: 0 auto;
   max-width: 800px;
   @media(max-width: 600px) {
     align-items: flex-start ;
   }
   @media(max-width: 1100px) {
     padding: 0 30px;
   }
`

export const SelMore = styled.div`
   margin-top: 48px;
   @media(max-width: 600px) {
      display: none;
  } 
`

export const Title = styled.div`
  font-size: 36px;
  width: 864px;
  font-weight: 700;
  line-height: 50px;
  color: #2A2637;
  text-align: center;
  margin-left: -30px;
  margin-bottom: 36px;
  @media(max-width: 600px) {
     text-align: left;
     width: 312px;
     line-height: 33px;
     margin-bottom: 32px;
     margin-top: 20px;
     font-size: 24px;
     font-weight: 700;
     margin-left: 0;
  } 
`

export const Text = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #2A2637;
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }
`

export const TextComment = styled.div`
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #4E4963;
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }
`

export const Block = styled.div`
  display: flex;
  justify-content: center;
`

export const Image = styled.img`
  max-width: 500px;
  margin-top: 36px;
  @media(max-width: 600px) {
    width: 250px;
  }
`

export const List = styled.ul`
  list-style: none;
  padding-left: 10px;
`;

export const TextList = styled.li`
  font-size: 18px;
  font-weight: 400;
  line-height: 32px;
  color: #2A2637;
  max-width: 700px;
  &:before {
      content: '•';
      margin-right: 8px; 
  }
  @media(max-width: 768px) {
     font-size: 16px;
     line-height: 28px;
  }
`

export const Indent = styled.div`
  height: 15px;
`

export const TextBold = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 29px;
  color: #2A2637;
  @media(max-width: 768px) {
     font-size: 14px;
     line-height: 28px;
  }
`

export const BlockQuote = styled.div`
  margin-top: 36px;
`
